
import sliders from './js/sliders.js'
import search from './js/search.js'
import accordion from './js/accordion.js'
import readMore from './js/readmore.js'
import WOW from './node_modules/wow.js/dist/wow.js'
const jQuery = require('jquery')
const Blazy = require('blazy')
require('magnific-popup')

const isHeaderFixed = !!(window.getComputedStyle(document.querySelector('header')).getPropertyValue('position') === 'fixed');

/* Mobile menu */
document.querySelector('#menu-icon').addEventListener('click', function () {
  document.querySelector('ul.menu').classList.toggle('show');
  document.querySelector('#menu-icon').classList.toggle('active');
  document.querySelector('body').classList.toggle('fixed');

  if (document.querySelector('ul.menu').classList.contains('show')) {
    document.querySelector('ul.menu').style.maxHeight = `calc(100vh - ${document.querySelector('header').scrollHeight}px)`;
  } else {
    document.querySelector('ul.menu').style.maxHeight = null;
  }
})

const blazy = new Blazy() // eslint-disable-line

// Magnific
var pics = []
jQuery.map(jQuery('.magnific, div.imageholder a, .popup.image.zoom'), function (elem, i) {
  if (!jQuery(elem).parents('.gallery').length) {
    pics.push(elem)
  }
})


if (pics.length) {
  jQuery(pics).magnificPopup({
    type: 'image',
    gallery: {
      enabled: true
    },
    disableOn: 400,
    closeBtnInside: true,
    enableEscapeKey: true,
    mainClass: 'mfp-with-zoom',
    zoom: {
      enabled: true,
      duration: 300,
      easing: 'ease-in-out'
    }
  })
}

jQuery('.content-popup').magnificPopup({
  type: 'inline',
  midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  closeBtnInside: true,
  enableEscapeKey: true
})

if (document.location.search.indexOf('newsletter') > -1) {
  jQuery.magnificPopup.open({
    items: {
      src: '#newsletter'
    },
    type: 'inline',
    closeBtnInside: true,
    enableEscapeKey: true
  }, 0)
}


// Alert message
const alertMessageContainer = document.querySelector('.alert');
// const $html = document.querySelector('html');
const $body = document.querySelector('body');
const $header = document.querySelector('header');

if (alertMessageContainer) {
  if (alertMessageContainer && sessionStorage.getItem('showAlert') === 'false') {
    alertMessageContainer.classList.add('hide');
    $body.classList.remove('has-alert');
  } else {
    alertMessageContainer.classList.remove('hide');
    $body.classList.add('has-alert');
  }

  const hideAlert = () => {
    alertMessageContainer.classList.add('hide');
    $body.classList.remove('has-alert');
    sessionStorage.setItem('showAlert', 'false');
    $body.style.borderTopWidth = null;
    // $body.style.scrollPaddingTop = null;
    // $html.style.scrollPaddingTop = null;
  };

  if ($body.classList.contains('has-alert') && window.getComputedStyle($header).getPropertyValue('position') === 'fixed') {
    $body.style.borderTopWidth = `${$header.scrollHeight}px`;
    // $body.style.scrollPaddingTop = `${$header.scrollHeight}px`;
    // $html.style.scrollPaddingTop = `${$header.scrollHeight}px`;
  }

  const resize = () => {
    if ($body.classList.contains('has-alert') && window.getComputedStyle($header).getPropertyValue('position') === 'fixed') {
      $body.style.borderTopWidth = `${$header.scrollHeight}px`;
      // $body.style.scrollPaddingTop = `${$header.scrollHeight}px`;
      // $html.style.scrollPaddingTop = `${$header.scrollHeight}px`;
    } else {
      $body.style.borderTopWidth = null;
      // $body.style.scrollPaddingTop = null;
      // $html.style.scrollPaddingTop = null;
    };
  }

  window.addEventListener('resize', () => {
    window.requestAnimationFrame(resize);
  });
  
 document.querySelector('.alert__button').addEventListener("click", hideAlert);
}



// Smooth scroll till target länkar 
jQuery('a[href^="#"]').click(function(e){
  e.preventDefault();
  var target = jQuery(jQuery(this).attr("href"));
  if(target.length){
    if(jQuery('header').css("position") === "fixed") {
      jQuery('html,body').animate({scrollTop: (target.offset().top - jQuery('header').outerHeight())},'slow');
    } else {
      jQuery('html,body').animate({scrollTop: target.offset().top},'slow');
    }
  }else{
    return;
  }
});

// Cookie message
const cookieMessageContainer = document.querySelector('.cookie-info');

if (cookieMessageContainer) {
  if (cookieMessageContainer && localStorage.getItem('showCookieInfo') === 'false') {
    cookieMessageContainer.classList.add('hide');
  } else {
    cookieMessageContainer.classList.remove('hide');
  }

  const hideCookieInfo = () => {
    cookieMessageContainer.classList.add('hide');
    localStorage.setItem('showCookieInfo', 'false');
  };

  document.querySelector('.cookie-info__button').addEventListener("click", hideCookieInfo);
}

const wow = new WOW()
wow.init()

sliders()
search(blazy, wow)
accordion()
readMore()
